<template>
    <div id="container">
        <div id="content">
            <h1>Quizzes and Rescheduled Exams</h1>
            <a :href="'/api/report/quizzes-and-reschedules.xlsx'" target="_blank">Download as CSV</a><br><br>
            <table v-loading="loading">
                <tbody>
                <tr>
                    <th></th>
                    <th># of exams 70 minutes or less</th>
                    <th> Total Rescheduled Exams</th>
                    <th> Total Rescheduled Quizzes</th>
                    <th> Total Time Change Exams</th>
                    <th> Total Time Change Quizzes</th>
                </tr>

                <template v-for="(row, index) in data">
                    <tr :key="index">
                        <td>{{ row.name }}</td>
                        <td>{{ row.total_quizzes }}</td>
                        <td>{{ row.total_rescheduled_exams }}</td>
                        <td>{{ row.total_rescheduled_quizzes }}</td>
                        <td>{{ row.total_retimed_exams }}</td>
                        <td>{{ row.total_retimed_quizzes }}</td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        metaInfo() {
            return {
                title: "Quizzes and Rescheduled Exams"
            }
        },
        components: {},
        data() {
            return {
                data: [],
                loading: false
            }
        },
        methods: {
            load: function () {
                this.loading = true;
                this.getData();

            },
            getData: function () {
                this.loading = true;
                axios.get('/api/report/quizzes-and-reschedules/')
                    .then(response => {
                        if (response.data.success) {
                            this.data = response.data.rows;

                            this.loading = false;
                        }
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                    });
            }
        },
        created() {
            this.load();
        }
    }
</script>
<style scoped>
</style>
